import CardTitle from "./CardTitle";

const Care = () => {
   return [
      <div>
         <CardTitle num={1} />
         <ul>
            <li>
               When we run into problems, we actively provide support without
               undermining the authority or confidence of the experts
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={2} />
         <ul>
            <li>All attendees are heard and encouraged</li>
            <li>
               Disagreements are respectful, respected and valued; we then
               collaborate on getting to the right answer
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={3} />
         <ul>
            <li>
               Clients / learners / Avado people’s needs are at the centre of
               our decisions; clients inspire us, learners inspire us and our
               people inspire us – our response is to inspire them all back
            </li>
            <li>Everyone’s ideas count</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={4} />
         <ul>
            <li>
               We care about our people’s health and happiness, their needs,
               their aspirations and their personal objectives
            </li>
            <li>
               We care about our clients’ and learners’ needs, aspirations and
               objectives
            </li>
            <li>We start with trust</li>
         </ul>
      </div>,

      <div>
         <CardTitle num={5} />
         <h3>We smile at: 😍</h3>
         <ul>
            <li>Helping each other out</li>
            <li>Socials, on or offline </li>
            <li>Meeting and exceeding client and learner needs</li>
         </ul>
         <br />
         <h3>We frown at: 😒</h3>
         <ul>
            <li>Egos, arrogance and self-importance</li>
            <li>Gossip and toxicity</li>
            <li>Challenging disrespectfully</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={6} />
         <ul>
            <li>Genuine recognition of life and work events</li>
            <li>Clear is kind</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={7} />
         <ul>
            <li>Radical honesty and clarity are kind</li>
            <li>(Radical Candor® is our delivery method)</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={9} />
         <ul>
            <li>We always look for positive intent</li>
            <li>
               Nurture an environment that supports great people and encourages
               them to support one another
            </li>
            <li>
               Candour (Radical Candor®) isn’t cruel; it’s a demonstration of
               empathy
            </li>
         </ul>
      </div>,

      <div>
         <CardTitle num={10} />
         <ul>
            <li>
               We see people for who they are as well as what they can bring
            </li>
            <li>We respect the learning curve</li>
            <li>
               Empathy is beautiful but it can be ruinous; Radical Candor® is
               key
            </li>
         </ul>
      </div>,
   ];
};

export default Care;
